module.exports = __webpack_public_path__ + "img/solution-title.e68e6404.png";